import type { Store } from '../data/store';
import { isMarysStore, isTestStore } from '../data/store';

// Reads the server-computed flag. The hardcoded allowlist is a transitional
// fallback for the deploy window (old backend hasn't sent `features` yet) and
// rehydrated cache; remove once web receiving is fully rolled out via the flag.
export const isReceivingEnabled = (store: Store): boolean =>
  store.features?.web_receiving ?? (isMarysStore(store) || isTestStore(store));
